import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e43e5c12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-grow-1 min-w-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-1 font-weight-bold" }, "Mi inscripción", -1))
const _hoisted_3 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis nombre"
}
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-center py-8"
}
const _hoisted_5 = { class: "text-body-2 mb-1" }
const _hoisted_6 = {
  key: 0,
  class: "text-medium-emphasis"
}
const _hoisted_7 = {
  key: 0,
  class: "text-caption text-medium-emphasis mb-3"
}
const _hoisted_8 = { class: "text-subtitle-2 font-weight-bold mt-2 mb-2" }
const _hoisted_9 = {
  key: 0,
  class: "text-body-2 font-weight-bold"
}
const _hoisted_10 = { class: "text-body-2" }
const _hoisted_11 = {
  key: 0,
  class: "text-medium-emphasis"
}
const _hoisted_12 = {
  key: 1,
  class: "d-flex ga-1 mt-3"
}
const _hoisted_13 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_14 = {
  key: 1,
  class: "text-center mt-4"
}
const _hoisted_15 = {
  key: 2,
  class: "text-caption text-medium-emphasis mt-3 mb-0"
}

import { computed, onMounted, ref } from "vue";
import { getIncripcionById } from "@/services/InscripcionesService";
import { InscripcionTorneoCreadoDTO } from "@/interfaces/Torneo";
import {
  CrearListaTorneoRequestDTO,
  ModificarListaTorneoRequestDTO,
  RequesListaDTO,
} from "@/interfaces/Lista";
import {
  getListasByInscripcion,
  getlistaTorneo,
  modificarListaTorneo,
  subirListaTorneo,
} from "@/services/ListasService";
import { ListaDTO } from "@/interfaces/Usuario";
import { esPorJornadas, FORMATO_COPA } from "@/Constant/FormatoTorneo";
import { useToast } from "@/composables/useToast";
import { diaDeHoy, ultimoDiaEvento } from "@/utils/Fecha";
import { estadoLista } from "@/utils/estadoLista";
import ModalLista from "./ModalLista.vue";
import ModalModificarLista from "./ModalModificarLista.vue";
import ModalEnviarLista from "./ModalEnviarLista.vue";
import InterruptorCompartirEmail from "./InterruptorCompartirEmail.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalInscripcion',
  props: {
    idInscripcion: {},
    idUsuario: {},
    idTorneo: {},
    idOrganizador: {},
    ejercitoElegido: {}
  },
  emits: ["close", "eliminar-inscripcion", "actualizada"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { triggerToast } = useToast();

const show = ref(true);
const cargando = ref(true);
const inscripcionData = ref<InscripcionTorneoCreadoDTO | null>(null);
const listasPorJugador = ref<ListaDTO[]>([]);
const torneo = computed(() => inscripcionData.value?.torneo ?? null);

// Liga y Copa: el ejército es el de la inscripción
const esLiga = computed(() => esPorJornadas(torneo.value?.formatoTorneo));
const esCopa = computed(() => torneo.value?.formatoTorneo === FORMATO_COPA);
const ejercitoFijo = computed(() => (esLiga.value ? props.ejercitoElegido ?? null : null));
// Al generar las jornadas el torneo pasa a tener tantas partidas como jornadas
const ligaEnMarcha = computed(() => esLiga.value && (torneo.value?.numeroPartidas ?? 0) > 1);
// Hasta su último día, incluido, se pueden enviar listas y darse de baja
const abierta = computed(
  () =>
    !!torneo.value &&
    ultimoDiaEvento(torneo.value.fechaInicioTorneo, torneo.value.fechaFinTorneo) >= diaDeHoy()
);
const pagado = computed(() => (inscripcionData.value?.esPago ?? "").toUpperCase() === "SI");

// Con una lista por jugador va en la inscripción; con varias, cada una por separado
const listas = computed(() => {
  const inscripcion = inscripcionData.value;
  if (!inscripcion || !torneo.value) return [];
  if (torneo.value.listasPorJugador <= 1)
    return [
      {
        indice: 1,
        estado: inscripcion.estadoLista,
        ejercito: inscripcion.ejercito,
        tieneLista: !!inscripcion.listaData,
        lista: null as ListaDTO | null,
      },
    ];
  return Array.from({ length: torneo.value.listasPorJugador }, (_, i) => {
    const lista = listasPorJugador.value[i] ?? null;
    return {
      indice: i + 1,
      estado: lista?.estadoLista ?? null,
      ejercito: lista?.ejercito ?? null,
      tieneLista: !!lista?.listaData,
      lista,
    };
  });
});

// Ver una lista: con una por jugador hay que pedir la imagen; con varias ya viene
const listaVisible = ref<number | null>(null);
const imagenVisible = ref<string | null>(null);
const cargandoLista = ref<number | null>(null);
const alternarLista = async (indice: number) => {
  if (listaVisible.value === indice) {
    listaVisible.value = null;
    return;
  }
  const lista = listas.value.find(l => l.indice === indice);
  if (lista?.lista) {
    imagenVisible.value = lista.lista.listaData ?? null;
    listaVisible.value = indice;
    return;
  }
  cargandoLista.value = indice;
  try {
    const response = await getlistaTorneo({ idTorneo: props.idTorneo, idUsuario: props.idUsuario });
    imagenVisible.value = response.data.listaData;
    listaVisible.value = indice;
  } catch (error) {
    console.error(error);
    triggerToast("error", "No se ha podido cargar la lista");
  } finally {
    cargandoLista.value = null;
  }
};

// Enviar o cambiar: los mismos modales y llamadas que antes
const currentInscripcionId = ref<number>();
const currentIdLista = ref<number>();
const showVerListaModal = ref(false);
const showModificarListaModal = ref(false);
const showEnviarListaModal = ref(false);
const hasLista = ref(false);

const enviarOCambiar = (indice: number) => {
  const inscripcion = inscripcionData.value;
  if (!inscripcion || !torneo.value) return;
  currentInscripcionId.value = inscripcion.idInscripcion;
  if (torneo.value.listasPorJugador <= 1) {
    hasLista.value = !!inscripcion.bando;
    if (inscripcion.idLista) {
      currentIdLista.value = inscripcion.idLista;
      showModificarListaModal.value = true;
    } else showVerListaModal.value = true;
    return;
  }
  const lista = listas.value.find(l => l.indice === indice)?.lista;
  if (lista?.idLista) {
    currentIdLista.value = lista.idLista;
    showModificarListaModal.value = true;
  } else showEnviarListaModal.value = true;
};

const alGuardarLista = async (texto: string) => {
  triggerToast("success", texto);
  listaVisible.value = null;
  emit("actualizada");
  await cargar();
};

const enviarLista = async (newLista: RequesListaDTO) => {
  if (!currentInscripcionId.value) return;
  const request: CrearListaTorneoRequestDTO = {
    idInscripcion: currentInscripcionId.value,
    listaData: newLista.listaData,
    ejercito: newLista.ejercito,
    idUsuario: props.idUsuario,
    idTorneo: props.idTorneo,
  };
  try {
    await subirListaTorneo(request);
    await alGuardarLista("Lista enviada");
  } catch (error) {
    console.error(error);
    triggerToast("error", "No se ha podido enviar la lista");
  } finally {
    showVerListaModal.value = false;
    showEnviarListaModal.value = false;
  }
};

const modificarLista = async (newLista: RequesListaDTO) => {
  if (currentIdLista.value == null) return;
  const request: ModificarListaTorneoRequestDTO = {
    listaData: newLista.listaData,
    idLista: currentIdLista.value,
    ejercito: newLista.ejercito,
    idUsuario: props.idUsuario,
    idTorneo: props.idTorneo,
  };
  try {
    await modificarListaTorneo(request);
    await alGuardarLista("Lista cambiada");
  } catch (error) {
    console.error(error);
    triggerToast("error", "No se ha podido cambiar la lista");
  } finally {
    showVerListaModal.value = false;
    showModificarListaModal.value = false;
  }
};

const eliminarInscripcion = () => {
  emit("eliminar-inscripcion", props.idInscripcion);
  show.value = false;
  emit("close");
};

const close = () => {
  show.value = false;
  emit("close");
};
// Cerrarlo pulsando fuera también avisa
const alCambiarVisible = (visible: boolean) => {
  if (!visible) emit("close");
};

const cargar = async () => {
  try {
    const response = await getIncripcionById(props.idInscripcion);
    inscripcionData.value = response.data;
    if (inscripcionData.value && (inscripcionData.value.torneo?.listasPorJugador ?? 0) > 1) {
      const listasResponse = await getListasByInscripcion(inscripcionData.value.idInscripcion);
      listasPorJugador.value = listasResponse.data;
    }
  } catch (error) {
    console.error("Error al obtener datos de la inscripcion:", error);
    triggerToast("error", "No se ha podido cargar la inscripción");
  } finally {
    cargando.value = false;
  }
};

onMounted(cargar);

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: show.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
        alCambiarVisible
      ],
      "max-width": "560",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex align-start ga-2 text-wrap pt-3" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _hoisted_2,
                  (torneo.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(torneo.value.nombreTorneo), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_v_btn, {
                  icon: "mdi-close",
                  variant: "text",
                  density: "comfortable",
                  "aria-label": "Cerrar",
                  onClick: close
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, { class: "text-left" }, {
              default: _withCtx(() => [
                (cargando.value || !inscripcionData.value || !torneo.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_v_progress_circular, {
                        indeterminate: "",
                        color: "primary"
                      })
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", {
                          class: _normalizeClass(pagado.value ? 'text-success' : 'text-warning')
                        }, _toDisplayString(pagado.value ? "Pagado" : "No pagado"), 3),
                        (ejercitoFijo.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, " · " + _toDisplayString(ejercitoFijo.value), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (ejercitoFijo.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Puedes cambiar de lista antes de cada partida, siempre de este ejército. "))
                        : _createCommentVNode("", true),
                      _createElementVNode("h3", _hoisted_8, _toDisplayString(listas.value.length > 1 ? "Tus listas" : "Tu lista"), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listas.value, (lista) => {
                        return (_openBlock(), _createBlock(_component_v_card, {
                          key: lista.indice,
                          variant: "outlined",
                          class: "pa-3 mb-2"
                        }, {
                          default: _withCtx(() => [
                            (listas.value.length > 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Lista " + _toDisplayString(lista.indice), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("span", {
                                class: _normalizeClass(`text-${_unref(estadoLista)(lista.estado).color}`)
                              }, _toDisplayString(_unref(estadoLista)(lista.estado).texto), 3),
                              (lista.ejercito)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, " · " + _toDisplayString(lista.ejercito), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (lista.tieneLista || abierta.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  (lista.tieneLista)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 0,
                                        size: "small",
                                        variant: "tonal",
                                        class: "accion text-none",
                                        loading: cargandoLista.value === lista.indice,
                                        onClick: ($event: any) => (alternarLista(lista.indice))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(listaVisible.value === lista.indice ? "Ocultar lista" : "Ver lista"), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["loading", "onClick"]))
                                    : _createCommentVNode("", true),
                                  (abierta.value)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 1,
                                        size: "small",
                                        variant: "tonal",
                                        class: "accion text-none",
                                        onClick: ($event: any) => (enviarOCambiar(lista.indice))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(lista.tieneLista ? "Cambiar lista" : "Enviar lista"), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_expand_transition, null, {
                              default: _withCtx(() => [
                                (listaVisible.value === lista.indice && imagenVisible.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                      _createVNode(_component_v_img, {
                                        src: imagenVisible.value,
                                        alt: "Lista de ejército",
                                        class: "rounded",
                                        contain: ""
                                      }, null, 8, ["src"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      _createVNode(InterruptorCompartirEmail, {
                        idInscripcion: inscripcionData.value.idInscripcion,
                        valor: inscripcionData.value.compartirEmail,
                        class: "mt-3"
                      }, null, 8, ["idInscripcion", "valor"]),
                      (abierta.value && !ligaEnMarcha.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createVNode(_component_v_btn, {
                              variant: "text",
                              color: "error",
                              size: "small",
                              class: "text-none",
                              onClick: eliminarInscripcion
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Darme de baja ")
                              ]),
                              _: 1
                            })
                          ]))
                        : (ligaEnMarcha.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(esCopa.value ? "La copa" : "La liga") + " ya está en marcha: si tienes que dejarla, habla con el organizador. ", 1))
                          : _createCommentVNode("", true)
                    ], 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (currentInscripcionId.value != null)
      ? (_openBlock(), _createBlock(ModalLista, {
          key: 0,
          isVisible: showVerListaModal.value,
          hasLista: hasLista.value,
          idInscripcion: currentInscripcionId.value,
          ejercitoFijo: ejercitoFijo.value,
          "onUpdate:isVisible": _cache[1] || (_cache[1] = ($event: any) => (showVerListaModal.value = $event)),
          onEnviarLista: enviarLista,
          onModificarLista: modificarLista
        }, null, 8, ["isVisible", "hasLista", "idInscripcion", "ejercitoFijo"]))
      : _createCommentVNode("", true),
    (showEnviarListaModal.value)
      ? (_openBlock(), _createBlock(ModalEnviarLista, {
          key: currentInscripcionId.value,
          isVisible: showEnviarListaModal.value,
          "onUpdate:isVisible": _cache[2] || (_cache[2] = ($event: any) => ((showEnviarListaModal).value = $event)),
          idInscripcion: currentInscripcionId.value!,
          idUsuario: props.idUsuario,
          idTorneo: props.idTorneo,
          hasLista: false,
          onEnviarLista: enviarLista,
          onModificarLista: modificarLista
        }, null, 8, ["isVisible", "idInscripcion", "idUsuario", "idTorneo"]))
      : _createCommentVNode("", true),
    _createVNode(ModalModificarLista, {
      isVisible: showModificarListaModal.value,
      idLista: currentIdLista.value!,
      ejercitoFijo: ejercitoFijo.value,
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (showModificarListaModal.value = $event)),
      onModificarListaMasDeUna: modificarLista
    }, null, 8, ["isVisible", "idLista", "ejercitoFijo"])
  ], 64))
}
}

})